import React from 'react';

import {Stack, Typography} from '@mui/material';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {ConsultProtocolsItem} from 'domain/usecases';
import {Protocol} from './Protocol';
import {ProtocolsResponseProps} from './types';
import {ProtocolStatusDrawer} from './ProtocolStatusDrawer';
import {useProtocols} from '../../hooks/useProtocols';

const {resultsFound, resultFound} = translations['pt-br'].commons;

export function Protocols({protocols, totalItems, shouldShowTotalItems}: ProtocolsResponseProps) {
	const {isMobile} = useMediaQueries();
	const {openDrawerState, protocolSelectedState, onOpenDrawer, onCloseDrawer, handleViewMore} =
		useProtocols();

	return (
		<Stack margin={isMobile ? 2 : '16px 32px'} gap={2}>
			{shouldShowTotalItems ? (
				<Typography variant="body1" color="text.secondary">
					<b>{totalItems}</b> {totalItems! === 1 ? resultFound : resultsFound}
				</Typography>
			) : null}

			{protocols?.map((protocol: ConsultProtocolsItem) => (
				<Protocol
					key={protocol.nuRegistro}
					protocol={protocol}
					handleViewMore={handleViewMore}
				/>
			))}

			{protocolSelectedState ? (
				<ProtocolStatusDrawer
					protocol={protocolSelectedState}
					onCloseDrawer={onCloseDrawer}
					onOpenDrawer={onOpenDrawer}
					openDrawer={openDrawerState}
				/>
			) : null}
		</Stack>
	);
}
